import { API_MASTER_DATA } from '../../service/index'
import axios from 'axios'

export default {
  state: {
    PreOrderDetail: null,
    CachePreorderTime: [] // [ 'text preorder time', 'value preorder time', 'index select date', 'index select preorder time' ]
  },
  mutations: {
    setPreOrderDetail (state, list) {
      state.PreOrderDetail = list
    }
  },
  actions: {
    setCachePreorderTime ({state}, payload) {
      state.CachePreorderTime = payload
    },
    async getPreorderDetail ({commit}, payload) {
      const preorder = await axios({
        method: 'GET',
        url: API_MASTER_DATA + 'restaurants/' + payload.restaurant_uuid + '/branches/' + payload.branch_uuid + '/preorder-time',
        responseType: 'json'
      }).then((response) => {
        return (response.data.meta.status === 200) ? response.data.data : []
      }).catch(() => {
        return []
      })
      commit('setPreOrderDetail', preorder)
      return preorder
    }
  },
  getters: {
    PreOrderDetail (state) {
      return state.PreOrderDetail
    },
    CachePreorderTime (state) {
      return state.CachePreorderTime
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/preorder/index.js